import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSimCard2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconSimCard2"><Path d="M18.25 2C19.2165 2 20 2.7835 20 3.75V20.25C20 21.2165 19.2165 22 18.25 22H5.75C4.7835 22 4 21.2165 4 20.25V7.57843C4 6.84908 4.28973 6.14961 4.80546 5.63388L7.63388 2.80546C8.14961 2.28973 8.84908 2 9.57843 2H11.5V7.25C11.5 7.66421 11.8358 8 12.25 8C12.6642 8 13 7.66421 13 7.25V2H15.5V7.25C15.5 7.66421 15.8358 8 16.25 8C16.6642 8 17 7.66421 17 7.25V2H18.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSimCard2;
